import { useEffect, useState, useMemo } from 'react';
import config from '../../config/config';
import states from '../../utilities/states';
import { regionLeadOptions, electedOptions } from '../../data/contactForm';
import { useParams } from 'react-router-dom';
import BasicFormInput from './BasicFormInput';
import BasicFormSelect from './BasicFormSelect';
import BasicFormDateInput from './BasicFormDateInput';
import { makeValidDateBody, makeUTCtoLocal } from '../../utilities/dates';
import axios from 'axios';

function UpdateContactForm() {
  const [isReady, setIsReady] = useState(false);

  const [name, setName] = useState('');
  const [region_lead, setRegionLead] = useState('');
  const [title, setTitle] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [ext, setExt] = useState('');

  const [affilName, setAffilName] = useState('');
  const [address_1, setAddress1] = useState('');
  const [address_2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('TX');
  const [zipcode, setZipcode] = useState('');

  const [startdate, setStartDate] = useState(new Date());
  const [enddate, setEndDate] = useState(new Date());
  const [term_enddate, setTermEndDate] = useState(new Date());
  const [elected, setElected] = useState(false);
  const [notes, setNotes] = useState('');

  // For dropdown
  const [affiliation_communities, setAffiliationCommunities] = useState([]);

  // Params and state
  let { affiliation_id } = useParams();
  let { contact_id } = useParams();
  let { poc_id } = useParams();

  const updateReference = useMemo(() => {
    const reference = {
      name: setName,
      region_lead: setRegionLead,
      title: setTitle,
      email: setEmail,
      phone: setPhone,
      ext: setExt,
      affiliation: setAffilName,
      address_1: setAddress1,
      address_2: setAddress2,
      city: setCity,
      state: setState,
      zipcode: setZipcode,
      startdate: setStartDate,
      enddate: setEndDate,
      term_enddate: setTermEndDate,
      elected: setElected,
      notes: setNotes
    };
    return reference;
  }, []);
  const dataWithDates = ['startdate', 'enddate', 'term_enddate'];
  const allowedUpdates = Object.keys(updateReference);

  //API calls

  async function updateUser(newData) {
    await axios
      .put(config.apiURL + `/contacts/${contact_id}`, newData, {
        headers: {
          'Content-Type': 'application/json',
          token: config.getToken()
        }
      })
      .then((res) => {
        alert('Contact information Updated');
        window.location = '/admin';
      });
  }

  useEffect(() => {
    async function getFormData() {
      await axios
        .get(
          config.apiURL +
            `/contacts?affiliation_id=${affiliation_id}&contact_id=${contact_id}&poc_id=${poc_id}`,
          {
            headers: {
              'Content-Type': 'application/json',
              token: config.getToken()
            }
          }
        )
        .then((response) => {
          setIsReady(true);
          let mainData = response.data[0];
          const updateList = Object.keys(mainData);

          updateList.forEach((key) => {
            if (!allowedUpdates.includes(key)) return;
            const data = mainData[key];

            if (typeof mainData[key] === 'object') {
              dataWithDates.includes(key)
                ? updateReference[key](
                    data.String ? makeUTCtoLocal(data.String) : null
                  )
                : updateReference[key](data.String);
            } else {
              updateReference[key](data);
            }
          });
        });
    }
    async function getAllAffiliations() {
      await axios
        .get(config.apiURL + `/affiliations/list`, {
          headers: {
            'Content-Type': 'application/json',
            token: config.getToken()
          }
        })
        .then((response) => {
          const communitiesList = response.data.map((name) => ({
            label: name,
            value: name
          }));
          return setAffiliationCommunities(communitiesList);
        });
    }

    if (isReady === false) {
      //if the result is not ready so you make the axios call
      getFormData();
      getAllAffiliations();
    }
  }, [isReady, affiliation_id, contact_id, poc_id, updateReference]); // eslint-disable-line react-hooks/exhaustive-deps

  function mySubmitHandler(event) {
    event.preventDefault();
    // Post request
    const postData = {
      // affiliation_id: affiliation_id,
      // poc_id: poc_id,
      name: name,
      region_lead: { String: region_lead, Valid: region_lead ? true : false },
      title: title,
      email: email,
      phone: phone,
      ext: ext,
      affiliation: affilName,
      address_1: address_1,
      address_2: address_2,
      city: city,
      state: state,
      zipcode: zipcode,
      elected: elected === 'true' ? true : false,
      startdate: makeValidDateBody(startdate),
      enddate: makeValidDateBody(enddate),
      term_enddate: makeValidDateBody(term_enddate),
      notes: { String: notes, Valid: notes ? true : false }
    };

    updateUser(postData);
  }

  function handleDateChange(name, value) {
    const synthEvent = {
      target: { name, value }
    };
    myChangeHandler(synthEvent);
  }

  const myChangeHandler = (event) => {
    const { name, value } = event.target;
    updateReference[name](value);
  };

  return (
    <div className='container all-center'>
      <div
        className='card text-center'
        style={{ background: '#54c5f1', width: '750px' }}
      >
        {isReady ? (
          <form onSubmit={mySubmitHandler}>
            <h3 style={{ textDecoration: 'underline' }}>
              Complete the Contact Information and hit submit:
            </h3>
            <div className='grid-container'>
              <div className='grid-item'>
                <BasicFormInput
                  label='*Person Name'
                  updateKey='name'
                  value={name}
                  onChange={myChangeHandler}
                />
                <BasicFormInput
                  label='*Title'
                  updateKey='title'
                  value={title}
                  onChange={myChangeHandler}
                />
                <BasicFormSelect
                  label='*Affiliation'
                  updateKey='affiliation'
                  value={affilName}
                  onChange={myChangeHandler}
                  options={affiliation_communities}
                />
                <BasicFormSelect
                  label='Region Lead'
                  updateKey='region_lead'
                  value={region_lead}
                  onChange={myChangeHandler}
                  options={regionLeadOptions}
                />
                <BasicFormSelect
                  label='Elected'
                  updateKey='elected'
                  value={elected}
                  onChange={myChangeHandler}
                  options={electedOptions}
                />
                <BasicFormDateInput
                  label='*Date Start'
                  updateKey='startdate'
                  value={startdate}
                  onChange={(val) => handleDateChange('startdate', val)}
                />
                <BasicFormDateInput
                  label='Date End'
                  updateKey='enddate'
                  value={enddate}
                  onChange={(val) => handleDateChange('enddate', val)}
                />
                <BasicFormDateInput
                  label='Term End Date'
                  updateKey='term_enddate'
                  value={term_enddate}
                  onChange={(val) => handleDateChange('term_enddate', val)}
                />
              </div>
              <div className='grid-item'>
                <BasicFormInput
                  label='Email Address'
                  updateKey='email'
                  value={email}
                  onChange={myChangeHandler}
                />
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}
                >
                  <BasicFormInput
                    label='Phone Number'
                    updateKey='phone'
                    value={phone}
                    onChange={myChangeHandler}
                  />
                  <BasicFormInput
                    label='Ext'
                    updateKey='ext'
                    value={ext}
                    onChange={myChangeHandler}
                  />
                </div>
                <BasicFormInput
                  label='Street Address'
                  updateKey='address_1'
                  value={address_1}
                  onChange={myChangeHandler}
                />
                <BasicFormInput
                  label='Street Address 2'
                  updateKey='address_2'
                  value={address_2}
                  onChange={myChangeHandler}
                />
                <BasicFormInput
                  label='City'
                  updateKey='city'
                  value={city}
                  onChange={myChangeHandler}
                />
                <BasicFormSelect
                  label='State'
                  updateKey='state'
                  value={state}
                  onChange={myChangeHandler}
                  options={states.map((st) => ({ label: st, value: st }))}
                />
                <BasicFormInput
                  label='Zipcode'
                  updateKey='zipcode'
                  value={zipcode}
                  onChange={myChangeHandler}
                />
              </div>
            </div>
            <div className='grid-container'>
              <div className='grid-item notes'>
                <label>Notes</label>
                <textarea
                  rows='3'
                  cols='20'
                  name='notes'
                  id='notes'
                  value={notes}
                  onChange={myChangeHandler}
                  style={{ width: '100%' }}
                />
              </div>
            </div>
            <br />
            <br />
            <button
              className='btn btn-primary'
              type='submit'
              id='addContactBtn'
            >
              Submit
            </button>
          </form>
        ) : (
          <p> ...Data Loading</p>
        )}
      </div>
    </div>
  );
}

export default UpdateContactForm;
